module.exports = __webpack_public_path__ + "static/media/arrow-link.aa62f183.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-link.svg
// module id = 902
// module chunks = 0